import { render, staticRenderFns } from "./CreatePQ.vue?vue&type=template&id=3a059028&"
import script from "./CreatePQ.vue?vue&type=script&lang=js&"
export * from "./CreatePQ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports